<template>
    <dl class="dl-horizontal">
        <dt>Type</dt>
        <dd>{{ unitType }}</dd>
        <dt>Make</dt>
        <dd>{{ make }}</dd>
        <dt>Model</dt>
        <dd>{{ model }}</dd>
        <dt>Year</dt>
        <dd>{{ year }}</dd>
        <dt>Length (Feet)</dt>
        <dd>{{ length }}</dd>
        <dt>ID</dt>
        <dd>{{ unitId }}</dd>
        <dt>License Number</dt>
        <dd>{{ licenseNum }}</dd>
        <dt>State</dt>
        <dd>{{ state }}</dd>
        <dt>CMV</dt>
        <dd>{{ cmv }}</dd>
    </dl>

</template>

<script>

export default {
  name: 'TowedUnitSummary',
  props: {
    'unitType': String,
    'year': String,
    'make': String,
    'model': String,
    'unitId': String,
    'licenseNum': String,
    'state': String,
    'length': String,
    'cmv': String,
  },
}
</script>

<style>
</style>
